export function setSpinnerState(state){
    return async function(dispatch){
        const action = { type : 'SET_SPINNER_STATE', payload : state}
        dispatch(action);
    }
}

